import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import isEmpty from 'lodash/isEmpty';

import { Instances, TimeDropDownOptions, } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import {
	makeSelectObject,
	makeSelectError,
	requestObject,
	makeSelectInProgress,
	makeSelectFilters,
} from '../../../../store/Object';

import Widget, {
	MapStatePropsType,
	DispatchPropsType,
	OwnPropsType,
} from '../../organisms/Overview/Widget';

const [start, end] = TimeDropDownOptions[3].value as Array<string>;

const WidgetFactory = (instanceId: Instances) => {
	const mapStateToProps = () => {
		const selectData = makeSelectObject(instanceId);
		const selectError = makeSelectError(instanceId);
		const smsSelectInProgress = makeSelectInProgress(Instances.smsOverview);
		const waSelectInProgress = makeSelectInProgress(Instances.whatsappOverview);
		const selectFilters = makeSelectFilters(instanceId);
		return (state: IStateType) => ({
			data: selectData(state) || [],
			error: selectError(state) || {},
			filters: selectFilters(state) || {},
			smsInProgress: smsSelectInProgress(state),
			waInprogress: waSelectInProgress(state),
			selectedFilter: state.dashboard.overviewFilterKey
		});
	};

	const mapDispatchToProps = {
		onLoad: (filters: { [key: string]: any }) =>
			requestObject(instanceId, undefined, isEmpty(filters) ? {
				timerange: {
					start_time: start,
					end_time: end,
				},
			} : filters),
		onReload: (filters: { [key: string]: any }) =>
			requestObject(instanceId, undefined, filters),
	};

	return connect<
		MapStatePropsType,
		DispatchPropsType,
		OwnPropsType,
		IStateType
	>(
		mapStateToProps,
		mapDispatchToProps
	)(withImmutablePropsToJS(Widget));
};

export default WidgetFactory;
